import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import pickBy from 'lodash/pickBy';
import map from 'lodash/map';

const useUtilFilters = (current_filters = {}, options = {}) => {
  const history = useHistory();
  const location = useLocation();

  const generateFilteredPath = useCallback(
    (new_filters = {}) => {
      const active_filters = pickBy({
        ...current_filters,
        ...new_filters,
      });
      const params = map(active_filters, (v, k) => `${k}=${v}`);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'pathname' does not exist on type '{}'.
      return `${options.pathname || location.pathname}?${params.join('&')}`;
    },
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'pathname' does not exist on type '{}'.
    [location, current_filters, options.pathname]
  );

  const applyFilters = (new_filters: $TSFixMe) => {
    history.push(generateFilteredPath(new_filters));
  };

  return { applyFilters, generateFilteredPath, filters: current_filters };
};

export default useUtilFilters;
